module.exports = __webpack_public_path__ + "img/scene-stage-pick-perspective.2b0ab0de.jpg";